import type { PaletteMode } from '@mui/material';

import type { QueryFilterSerialized } from '/common/models';
import { SidebarSide } from '/shared/Sidebar/types';

export enum AssetsView {
  List = 'list',
  Masonry = 'masonry',
}

export enum AppsView {
  List = 'list',
  Tile = 'Tile',
}

export interface ITimelineState {
  open: boolean;
  searchMode: boolean;
  filterBy: QueryFilterSerialized;
  moduleTimelineSelected: boolean;
}

export const initialTimelineState: ITimelineState = {
  open: false,
  searchMode: false,
  filterBy: {},
  moduleTimelineSelected: true,
};

export interface IUIState {
  navSidebarOpen: boolean;
  navSidebarSide: SidebarSide;
  timeline: ITimelineState;
  isHints: boolean;
  isSplashScreen: boolean;
  assetsView: AssetsView;
  appsView: AppsView;
  currentThemeMode: PaletteMode;
  isTableTimeRangeRelative: boolean;
  openControlBarPromotionDialog: boolean;

  [key: string]: unknown;
}

export const uiInitialState: IUIState = {
  navSidebarOpen: false,
  navSidebarSide: SidebarSide.Left,
  timeline: initialTimelineState,
  isHints: true,
  isSplashScreen: false,
  assetsView: AssetsView.List,
  appsView: AppsView.List,
  currentThemeMode: 'light',
  isTableTimeRangeRelative: false,
  openControlBarPromotionDialog: false,
};
